import { render, staticRenderFns } from "./ArtworkHeaderPreview.vue?vue&type=template&id=32acc05e&"
import script from "./ArtworkHeaderPreview.vue?vue&type=script&lang=js&"
export * from "./ArtworkHeaderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports